import type { CommonData } from '@/app/common/createCommonData.ts';
import type { ABTests } from '@lmn/lmn-commonlogic/dist/config/abtest/ABTestsTypes';

// For logged in and not logged in users, always use the uuid from Casper (from the MPT)
export const getUUID = (commonData: CommonData) => commonData.userUid;

type AmpliABTests = {
  'ab test name': string[];
  'ab test version': string[];
};

export const getABTests = (abTests: ABTests | undefined = []): AmpliABTests => ({
  'ab test name': abTests.reduce(
    (result: string[], abTest) => (abTest.version ? [...result, abTest.experimentName] : result),
    []
  ),
  'ab test version': abTests?.reduce(
    (result: string[], abTest) => (abTest.version ? [...result, abTest.version] : result),
    []
  ),
});
